export default {
    getPosts(state) {
        return state.posts;
    }
}